import { useContext } from 'react';
import { Table, TableHead, TableBody, TableFooter, TableRow, TableCell, TablePagination, Checkbox } from '@material-ui/core';
import { CircleLoader, DeleteIconButton, PageContent, RegistrationStatus, RestoreIconButton, ViewIconButton } from 'components';
import { registrationsContext } from '../RegistrationsContext';
import Moment from 'react-moment';
import { UserType } from 'helpers/enums';
import { applicationContext, appUserContext } from 'helpers/services';


let Results = () => {
    let { countries } = useContext(applicationContext);
    let { currentUser } = useContext(appUserContext);
    let service = useContext(registrationsContext);


    return (
        <PageContent>
            {service.isLoading && <CircleLoader />}
            {service.isLoading === false &&
                <>
                    <Table>
                        <TableHead>
                            <TableRow>
                                {currentUser?.userType === UserType.Videndum &&
                                    <TableCell padding="checkbox">
                                        <Checkbox
                                            color="secondary"
                                            indeterminate={service.selectedItems.length > 0 && service.registrations.length > service.selectedItems.length}
                                            checked={service.selectedItems.length === service.registrations.length}
                                            onChange={(e) => service.selectAllRegistrations(e.target.checked)}
                                        />
                                    </TableCell>
                                }
                                <TableCell>Firstname</TableCell>
                                <TableCell>Lastname</TableCell>
                                <TableCell>Email</TableCell>
                                <TableCell>Country</TableCell>
                                <TableCell>SKU</TableCell>
                                <TableCell>Reg. Date</TableCell>
                                <TableCell align="right">Ext. Months</TableCell>
                                <TableCell align="right">Status</TableCell>
                                <TableCell />
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {service.registrations.map(registration =>
                                <TableRow hover key={registration.registrationId}>
                                    {currentUser?.userType === UserType.Videndum &&
                                        <TableCell padding="checkbox">
                                            <Checkbox
                                                color="secondary"
                                                checked={service.selectedItems.indexOf(registration.registrationId) !== -1}
                                                onChange={(e) => service.updateSelectedItems(registration.registrationId)}
                                            />
                                        </TableCell>
                                    }
                                    <TableCell>{registration.firstName}</TableCell>
                                    <TableCell>{registration.lastName}</TableCell>
                                    <TableCell>{registration.email}</TableCell>
                                    <TableCell>{countries.getValueByKey(registration.userCountryCode)}</TableCell>
                                    <TableCell>{registration.sku}</TableCell>
                                    <TableCell>
                                        <Moment date={registration.registrationDate} format="L" />
                                    </TableCell>
                                    <TableCell align="right">
                                        {registration.unlimited === true && 'Unlimited warranty'}
                                        {registration.unlimited === false && registration.extensionMonths}
                                    </TableCell>
                                    <TableCell align="right">
                                        <RegistrationStatus
                                            isExtended={registration.hasWarrantyExtension}
                                            isPreGolive={registration.isPreGolive}
                                        />
                                    </TableCell>
                                    <TableCell align="right">
                                        <ViewIconButton link={`/registration/${registration.registrationId}`} />
                                        {registration.isDeleted === false &&
                                            <DeleteIconButton onClick={() => service.deleteRegistration(registration)} />
                                        }
                                        {registration.isDeleted === true &&
                                            <RestoreIconButton onClick={() => service.restoreRegistration(registration)} />
                                        }
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                        {service.registrations.length === 0 &&
                            <TableFooter>
                                <TableRow>
                                    <TableCell colSpan={currentUser?.userType === UserType.Videndum ? 10 : 9}>
                                        <i>No registrations found</i>
                                    </TableCell>
                                </TableRow>
                            </TableFooter>
                        }
                    </Table>
                    <TablePagination
                        component="div"
                        count={service.recordCount}
                        onPageChange={(e, page) => service.changePage(page)}
                        page={service.search.pageNr}
                        rowsPerPage={service.search.pageSize}
                        rowsPerPageOptions={[service.search.pageSize]}
                        labelDisplayedRows={({ page }) =>
                            <span>Page {page + 1} of {Math.ceil(service.recordCount / service.search.pageSize)}</span>
                        }
                    />
                </>
            }
        </PageContent >
    )
}

export default Results;